module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/MO-cf2310de2f679e7060ead8d9c60212fc.png";